// Paginations/SecurityHoldersPagination.jsx
import { Pagination } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const SecurityHoldersPagination = ({ 
  currentPage, 
  totalPages, 
  totalItems,
  itemsPerPage,
  onPageChange,
  className = ''
}) => {
  // CORRECTION: totalPages > 0 au lieu de totalPages <= 1
  if (!totalPages || totalPages <= 0) return null;

  const startItem = ((currentPage - 1) * itemsPerPage) + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const renderPageItems = () => {
    const items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Bouton Première page
    if (startPage > 1) {
      items.push(
        <Pagination.Item 
          key="first" 
          onClick={() => onPageChange(1)}
          active={false}
        >
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }

    // Pages
    for (let page = startPage; page <= endPage; page++) {
      items.push(
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Pagination.Item>
      );
    }

    // Bouton Dernière page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item 
          key="last" 
          onClick={() => onPageChange(totalPages)}
          active={false}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div className={`d-flex justify-content-between align-items-center ${className}`}>
      <div className="text-muted small">
        Affichage de <strong>{startItem}</strong> à <strong>{endItem}</strong> 
        sur <strong>{totalItems}</strong> détenteur(s)
      </div>
      
      <Pagination className="mb-0">
        <Pagination.Prev
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="d-flex align-items-center"
        >
          <FaChevronLeft className="me-1" size={12} />
          
        </Pagination.Prev>
        
        {renderPageItems()}
        
        <Pagination.Next
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="d-flex align-items-center"
        >
          
          <FaChevronRight className="ms-1" size={12} />
        </Pagination.Next>
      </Pagination>
    </div>
  );
};

export default SecurityHoldersPagination;